import styles from './ProductTab.module.scss';
import parse from 'html-react-parser';

export default function MoreDetails(props) {
  return (
    <>
         {
            props.description &&
                <>
                    <div id={`more-details`}>
                        <h3 className={`py-4`}>More Details</h3>
                        <div className={`ms-2 mx-sm-4 ${styles.moreDetails}`}>
                            {
                                parse(props.description)
                            }
                        </div>
                    </div>
                </>
        }
    </>
  )
}
